export const Sections = {
  None: 0,
  Profile: 1,
  Clientes: 2,
  Usuarios: 3,
  Asociados: 4,
  Productos: 5,
  Configuraciones: 6,
  Ventas: 7,
  Cobranza: 8,
  Notificaciones: 9,
};

export const SubSections = {
  None: 0,
  Dashboard: 1,
  Catalogo: 2,
  CaracteristicasSKU: 3,
  Compras: 4,
  Proveedores: 5,
  Ventas: 6,
  Devoluciones: 7,
  PedidosEspeciales: 8,
  Asociados: 9,
  Historial: 10,
  Pagos: 11,
  Metas: 12,
  OrdenesVenta: 13,
  Bonificaciones: 14,
  Roles: 15,
  Paquetes: 16,
  Principal: 17,
  Conciliacion: 18,
  Comision: 19,
  Reestructura: 20,
};

export function SectionsToString(sectionId) {
  const values = {
    0: "None",
    1: "Perfil",
    2: "Clientes",
    3: "Usuarios",
    4: "Asociados",
    5: "Productos",
    6: "Configuraciones",
    7: "Ventas",
    8: "Cobranza",
    9: "Notificaciones",
  };
  return (values[sectionId] ?? values[0]).toLowerCase();
}

const navList = Object.freeze([
  {
    _id: Sections.Profile,
    name: "Perfil",
    icon: "bi bi-person",
  },
  {
    _id: Sections.Configuraciones,
    name: "Configuraciones",
    icon: "bi bi-gear",
    subs: [
      {
        _id: SubSections.Principal,
        remoteid: "principal",
        name: "Principal",
        icon: "bi bi-database-fill-gear",
      },
      {
        _id: SubSections.Roles,
        remoteid: "roles",
        name: "Roles",
        icon: "bi bi-database-fill-lock",
      },
      {
        _id: SubSections.Bonificaciones,
        remoteid: "bonificaciones",
        name: "Bonificaciones",
        icon: "bi bi-gift-fill",
      },
      {
        _id: SubSections.Paquetes,
        remoteid: "paquetes",
        name: "Paquetes",
        icon: "bi bi-file-earmark-plus-fill",
      },
      {
        _id: SubSections.Comision,
        remoteid: "paquetes",
        name: "Comisiones",
        icon: "bi bi-file-earmark-plus-fill",
      },
    ],
  },
  {
    _id: Sections.Usuarios,
    name: "Usuarios",
    icon: "bi bi-person-gear",
  },
  {
    _id: Sections.Notificaciones,
    name: "Notificaciones",
    icon: "bi bi-pass",
    subs: [
      {
        _id: SubSections.Asociados,
        remoteid: "asociados",
        name: "Asociados",
        icon: "bi bi-people-fill",
      },
      {
        _id: SubSections.OrdenesVenta,
        remoteid: "asociados",
        name: "Ordenes de Venta",
        icon: "bi bi-stickies-fill",
      },
    ],
  },
  {
    _id: Sections.Asociados,
    name: "Asociados",
    icon: "bi bi-people",
    subs: [
      {
        _id: SubSections.Dashboard,
        remoteid: "dashboard",
        name: "Dashboard",
        icon: "bi bi-clipboard2-pulse-fill",
      },
      {
        _id: SubSections.Catalogo,
        remoteid: "catalogo",
        name: "Catalogo",
        icon: "bi bi-file-earmark-richtext-fill",
      },
    ],
  },
  {
    _id: Sections.Clientes,
    name: "Clientes",
    icon: "bi bi-person-vcard",
    subs: [
      {
        _id: SubSections.Dashboard,
        remoteid: "dashboard",
        name: "Dashboard",
        icon: "bi bi-clipboard2-pulse-fill",
      },
      {
        _id: SubSections.Catalogo,
        remoteid: "catalogo",
        name: "Catalogo",
        icon: "bi bi-file-earmark-richtext-fill",
      },
    ],
  },
  {
    _id: Sections.Productos,
    name: "Productos",
    icon: "bi bi-postcard",
    subs: [
      {
        _id: SubSections.Dashboard,
        remoteid: "dashboard",
        name: "Dashboard",
        icon: "bi bi-clipboard2-pulse-fill",
      },
      {
        _id: SubSections.Catalogo,
        remoteid: "catalogo",
        name: "Catalogo",
        icon: "bi bi-file-earmark-richtext-fill",
      },
      {
        _id: SubSections.CaracteristicasSKU,
        remoteid: "caracteristicas",
        name: "Caracteristicas SKU",
        icon: "bi bi-postcard-fill",
      },
      {
        _id: SubSections.Compras,
        remoteid: "compras",
        name: "Compras",
        icon: "bi bi-credit-card-2-front-fill",
      },
      {
        _id: SubSections.Proveedores,
        remoteid: "proveedores",
        name: "Proveedores",
        icon: "bi bi-bus-front-fill",
      },
    ],
  },

  {
    _id: Sections.Ventas,
    name: "Ventas",
    icon: "bi bi-cash-coin",
    subs: [
      {
        _id: SubSections.Metas,
        remoteid: "metas",
        name: "Metas",
        icon: "bi bi-bar-chart-line-fill",
      },
      {
        _id: SubSections.Dashboard,
        remoteid: "dashboard",
        name: "Dashboard",
        icon: "bi bi-clipboard2-pulse-fill",
      },
      {
        _id: SubSections.Ventas,
        remoteid: "ordenes",
        name: "Ordenes de Venta",
        icon: "bi bi-cart4",
      },
      {
        _id: SubSections.Devoluciones,
        remoteid: "devoluciones",
        name: "Devoluciones",
        icon: "bi bi-cart-x-fill",
      },
      {
        _id: SubSections.PedidosEspeciales,
        remoteid: "pedidosespeciales",
        name: "Pedidos Especiales",
        icon: "bi bi-cart-check-fill",
      },
    ],
  },
  {
    _id: Sections.Cobranza,
    name: "Cobranza",
    icon: "bi bi-coin",
    subs: [
      {
        _id: SubSections.Dashboard,
        remoteid: "dashboard",
        name: "Dashboard",
        icon: "bi bi-clipboard2-pulse-fill",
      },
      {
        _id: SubSections.Metas,
        remoteid: "dashboard",
        name: "Estados de Cuenta",
        icon: "bi bi-person-vcard-fill",
      },
      {
        _id: SubSections.Conciliacion,
        remoteid: "asociados",
        name: "Conciliación",
        icon: "bi bi-duffle-fill",
      },
      {
        _id: SubSections.Reestructura,
        remoteid: "historial",
        name: "Reestructura",
        icon: "bi bi-postcard-fill",
      },
      /* {
        _id: SubSections.Pagos,
        remoteid: "pagos",
        name: "Reestructura Parcial",
        icon: "bi bi-pip-fill",
      },*/
    ],
  },
]);

export default navList;
